export default "__VITE_ASSET__b9e7cd98__"